'use strict';

var hasOwnProp = Object.prototype.hasOwnProperty;

function hasProp(obj, key) {
  return hasOwnProp.call(obj, key);
}

module.exports = hasProp;



//////////////////
// WEBPACK FOOTER
// ./node_modules/inflected/lib/hasProp.js
// module id = 1123
// module chunks = 0